module.exports = __webpack_public_path__ + "media/Prato.55dd95ba.mp3";